<sd-component-wrapper
  [content]="wrapperContent"
  [themesConfig]="lameConfig?.faqs?.backgroundTheme"
  [brand]="brand"
  id="ProductFaqsComponent_{{pdpType.charAt(0).toUpperCase() + pdpType.slice(1).toLowerCase()}}Page_1"
>
  <wc-base-faq
    sd-component-wrapper-component
    [faqEntries]="faqs"
    [pdpType]="pdpType"
    [titleLevel]="3"
  />
</sd-component-wrapper>
